// extracted by mini-css-extract-plugin
export default {"root":"styles_root__EfwOt","leftPanel":"styles_leftPanel__SPf0Y","container":"styles_container__CBDn5"};